import type { TypedDocumentNode } from "urql";

import { gql } from "urql";

import type {
  getBatchClaimHeaderInfoQuery,
  getBatchClaimHeaderInfoQueryVariables,
} from "../gql/graphql";

export const getBatchClaimHeaderInfoQueryDoc = gql`
  query getBatchClaimHeaderInfo(
    $batchClaimId: UUID!
    $shouldShowExtendedFields: Boolean!
  ) {
    batchClaim(id: $batchClaimId) {
      __typename
      id
      permissions
      nodeId
      claimAuditType
      computationStrategy
      paymentRate
      provider {
        __typename
        id
        name
        npi
        practiceType
        spec
      }
      auditDocumentation {
        __typename
        fileName
        id
        process
        signedUrl
        size
        subFile
      }
      icn
      claimType
      clientGroupName
      dateOfServiceStart
      dateOfServiceEnd
      dateAdmit
      dateDischarge
      amountReimbursed
      amountCharged
      batchClaimLines {
        nodes {
          id
          revCode
          paymentRate
        }
      }
      stageTracker {
        __typename
        canChangeStage
        changeStageDisabledReason
        currentStageEnteredAt
        visitedStageIds
        currentStage {
          __typename
          description
          id
          labelOrder
          name
          slug
          sortOrder
          type
          stageDetail
        }
        nextRecommendedStage {
          __typename
          description
          id
          labelOrder
          name
          slug
          sortOrder
          type
        }
        suggestedStages {
          __typename
          priority
          stage {
            __typename
            description
            id
            labelOrder
            name
            slug
            sortOrder
            type
          }
        }
        phases {
          __typename
          description
          id
          labelOrder
          name
          slug
          sortOrder
          stages {
            __typename
            description
            id
            labelOrder
            name
            slug
            sortOrder
            type
          }
        }
        blockers {
          __typename
          canChangeSegment
          createdAt
          description
          id
          status
          title
          createdDuringStage {
            __typename
            description
            id
            labelOrder
            name
            slug
            sortOrder
            type
          }
          segments {
            __typename
            id
            label
            name
            slug
            status
          }
          segmentHistory {
            __typename
            enteredAt
            exitedAt
            id

            context
            segment {
              __typename
              id
              label
              slug
              status
            }
          }
        }
        stageHistory {
          __typename
          appliedByUserId
          enteredAt
          exitedAt
          id
          stage {
            __typename
            description
            id
            labelOrder
            name
            slug
            sortOrder
            type
          }
        }
      }
      batchClaimState: batchClaimStateById {
        __typename
        id
        onHoldClaimState
        documentationClaimState
        reported
        disputedFindingClaimState
        workflowClaimState
        negotiationClaimState
        providerSignOffClaimState
        clientSignOffClaimState
        invoiceClaimState
        isProviderActive
        isRealized
        determinedDiscrepantAmount
        potentialDiscrepantAmount
        potentialClientSavings
        determinedClientSavings
        potentialAdjustedAllowedAmount
        determinedAdjustedAllowedAmount
        stage {
          description
          id
          labelOrder
          name
          phase {
            labelOrder
            name
          }
          type
        }
      }
      activeAssignees @include(if: $shouldShowExtendedFields) {
        __typename
        nodes {
          __typename
          id
          firstName
          lastName
        }
      }
      claimAuditor @include(if: $shouldShowExtendedFields) {
        __typename
        id
        firstName
        lastName
      }
    }
  }
` as TypedDocumentNode<
  getBatchClaimHeaderInfoQuery,
  getBatchClaimHeaderInfoQueryVariables
>;
